export const options = [
  { label: 'Product', path: '/product', completed: false, disabled: false },
  { label: 'Agreement', path: '/agreement', completed: false, disabled: false },
  { label: 'Design Files', path: '/files', completed: false, disabled: false },
];
